var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "94.565 50.862 100 65.413",
    enableBackground: "new 94.565 50.862 100 65.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Brand-logoTopPath",
    fill: "#48ce65",
    d: "M155.66 50.902s-35.025-2.09-61.095 23.88l39.7 12.04s22.49-28.158 60.3-25.87l-38.905-10.05zm-13.533 13.134c-6.27 0-11.244-1.493-11.244-3.284 0-1.79 5.075-3.284 11.244-3.284 6.27 0 11.244 1.493 11.244 3.284 0 1.792-4.974 3.284-11.243 3.284z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Brand-logoMiddlePath",
    fill: "#48ce65",
    d: "M193.47 63.04c-33.035.2-58.308 30.946-58.308 30.946L98.048 81.55l4.18 9.352 33.133 11.443s25.97-37.512 57.712-38.607l.398-.697z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Brand-logoBottomPath",
    fill: "#48ce65",
    d: "M192.177 65.828c-27.96 2.488-55.92 43.682-55.92 43.682L105.61 97.867l3.582 7.86 26.965 10.548c20.597-31.74 40.896-47.264 55.522-49.552l.497-.895z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarImg);
export default __webpack_public_path__ + "static/media/dollarImg.9249fd32bb15c9038777d2abccd0b168.svg";
export { ForwardRef as ReactComponent };